import {
  GeneralResourceDetail,
  MpxItemResponse,
  MpxResponseError,
  ProgramEngagementsAPI,
  UpdateTaskDataArguments,
} from '@cibo/core'
import { useInvalidateBatchedFields } from '@cibo/landmanager'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { PROGRAMS_QUERY_KEY } from './queryKey'

export const useUpdateEngagementTaskData = ({
  engagementId,
  taskId,
}: Partial<Omit<UpdateTaskDataArguments, 'updates'>>) => {
  const queryClient = useQueryClient()

  const invalidateBatchedFields = useInvalidateBatchedFields()

  return useMutation<
    MpxItemResponse<GeneralResourceDetail> | void,
    AxiosError<MpxResponseError>,
    Pick<UpdateTaskDataArguments, 'updates'>
  >({
    mutationKey: [PROGRAMS_QUERY_KEY.UPDATE_TASK_DATA],
    mutationFn: ({ updates }: Pick<UpdateTaskDataArguments, 'updates'>) => {
      return !!engagementId && !!taskId
        ? ProgramEngagementsAPI.updateTaskData({ engagementId, taskId, updates })
        : Promise.resolve()
    },
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({
        queryKey: [PROGRAMS_QUERY_KEY.TASK_DATA],
      })
      queryClient.invalidateQueries({
        queryKey: [PROGRAMS_QUERY_KEY.PROGRAM_ENGAGEMENTS, engagementId],
      })
      queryClient.invalidateQueries({
        queryKey: [PROGRAMS_QUERY_KEY.PROGRAM_ENGAGEMENT_DETAILS, engagementId],
      })
      invalidateBatchedFields(variables.updates.fieldDetails?.map(f => f.resourceId) || [])
    },
  })
}
